import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../axiosConfig';

const DONE_STATUS = 'done';

export const getAlerts = createAsyncThunk(
  'smart-alerts/getAlerts',
  async () => {
    const response = await apiConfig.get('/smart-alerts');
    const data = await response.data;
    return data;
  },
);

export const getAlertById = createAsyncThunk(
  'smart-alerts/getAlertById',
  async ({ alertId }) => {
    const response = await apiConfig.get(`/smart-alerts/${alertId}`);
    const data = await response.data;
    return data;
  },
);

export const updateAlert = createAsyncThunk(
  'smart-alerts/update',
  async ({ formValues, headers }) => {
    const alertId = formValues.id;
    const response = await apiConfig.put(
      `/smart-alerts/${alertId}`,
      formValues,
      {
        headers,
      },
    );
    const data = await response.data;
    return data;
  },
);

export const addAlert = createAsyncThunk(
  'smart-alerts/add',
  async ({ formValues, headers }) => {
    // eslint-disable-next-line no-param-reassign
    formValues.status = 'DISABLED';
    const response = await apiConfig.post(`/smart-alerts`, formValues, {
      headers,
    });
    const data = await response.data;
    return data;
  },
);

export const deleteAlert = createAsyncThunk(
  'smart-alerts/delete',
  async ({ alertId, headers }) => {
    const response = await apiConfig.delete(`/smart-alerts/${alertId}`, {
      headers,
    });
    const data = await { ...response.data, id: alertId };

    return data;
  },
);

export const getIncidents = createAsyncThunk(
  'smart-alerts/getIncidents',
  async () => {
    const response = await apiConfig.get('/smart-alerts/incidents');
    const data = await response.data;
    return data;
  },
);

const smartAlerstSlice = createSlice({
  name: 'smart-alerts',
  initialState: {
    alerts: [],
    incidents: [],
    selectedAlert: undefined,
  },
  reducers: {
    removeSelectedAlert: (state) => {
      state.selectedAlert = undefined;
    },
  },
  extraReducers: {
    [getAlerts.fulfilled]: (state, action) => {
      state.status = DONE_STATUS;
      if (!action.payload || !action.payload.data) {
        return;
      }
      state.alerts = [...action.payload.data];
    },
    [getAlertById.fulfilled]: (state, action) => {
      state.status = DONE_STATUS;
      if (!action.payload || !action.payload.data) {
        return;
      }
      state.selectedAlert = action.payload.data;
    },
    [updateAlert.fulfilled]: (state, action) => {
      state.status = DONE_STATUS;
      if (!action.payload || !action.payload.data) {
        return;
      }
      state.alerts[
        state.alerts.findIndex((obj) => obj.id === action.payload.data.id)
      ] = action.payload.data;
    },
    [deleteAlert.fulfilled]: (state, action) => {
      if (action.payload.status !== 'OK') {
        return;
      }

      const alerts = [...state.alerts];
      const deletedId = action.payload.id;
      const deletedAlertIndex = alerts.findIndex(
        (alert) => alert.id === deletedId,
      );
      alerts.splice(deletedAlertIndex, 1);
      state.alerts = [...alerts];
    },
    [getIncidents.fulfilled]: (state, action) => {
      state.status = DONE_STATUS;
      if (!action.payload || !action.payload.data) {
        return;
      }
      state.incidents = [...action.payload.data];
    },
  },
});

export const smartAlertsActions = smartAlerstSlice.actions;
export default smartAlerstSlice.reducer;
